import { useEffect } from "react";
import { useLocation } from "react-router-dom";
// @mui
import { Box, Stack, Drawer, Typography } from "@mui/material";
// hooks
import useResponsive from "../../../hooks/useResponsive";
// config
import { NAV } from "../../../config";
// components
import Logo from "../../../components/logo";
import Scrollbar from "../../../components/scrollbar";
import { NavSectionVertical } from "../../../components/nav-section";
//
import navConfig from "./config";
import NavAccount from "./NavAccount";
import Label from "src/components/label";
import { useAuthContext } from "src/auth/useAuthContext";
import { fCurrency } from "src/utils/formatNumber";

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { pathname } = useLocation();
  const { user } = useAuthContext();

  const isDesktop = useResponsive("up", "lg");

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
        }}
      >
        <Logo />

        <NavAccount />
        <Stack
          sx={{
            bgcolor: "success.lighter",
            border: (theme) => `1px solid ${theme.palette.success.main}`,
            borderRadius: 2,
            p: 1,
          }}
        >
          <Typography variant="subtitle2" textAlign={"center"}>
            Investment Wallet
          </Typography>
          <Typography variant="body2" textAlign={"center"}>
            {fCurrency(user?.investmentWallet?.balance || "0")}
          </Typography>
        </Stack>
        <Stack
          sx={{
            bgcolor: "warning.lighter",
            border: (theme) => `1px solid ${theme.palette.warning.main}`,
            borderRadius: 2,
            p: 1,
          }}
        >
          <Typography variant="subtitle2" textAlign={"center"}>
            Earning Wallet
          </Typography>
          <Typography variant="body2" textAlign={"center"}>
            {fCurrency(user?.earningWallet?.balance || "0")}
          </Typography>
        </Stack>
      </Stack>

      <NavSectionVertical data={navConfig} />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
              bgcolor: "transparent",
              borderRightStyle: "dashed",
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
